export class RefreshUnauthorizedError extends Error {
  constructor() {
    super('Refresh rejected by server');
    this.name = 'RefreshUnauthorizedError';
  }
}

export class RefreshNetworkError extends Error {
  constructor(cause) {
    super('Refresh network error');
    this.name = 'RefreshNetworkError';
    this.cause = cause;
  }
}
